export default "__VITE_ASSET__Dkd9NNrO__"